import { Navigate, Route, useLocation } from 'react-router-dom'

import ProjectDetail from '../projects/projectDetail'
import { isProjectWidgetMode, PUBLIC_ROUTES } from '../../routes'

import styles from './widgetProjectRoutes.module.css'

const WidgetOnly = ({ children }) => {
    const location = useLocation()

    if (!isProjectWidgetMode(location.search)) {
        return <Navigate to={PUBLIC_ROUTES.login} replace />
    }

    return <div className={styles.widgetShell}>{children}</div>
}

export const WidgetProjectRouteElements = () => (
    <>
        <Route
            path="/dashboard/projects/:id"
            element={
                <WidgetOnly>
                    <ProjectDetail />
                </WidgetOnly>
            }
        />
        <Route
            path="/dashboard/projects/:id/:view"
            element={
                <WidgetOnly>
                    <ProjectDetail />
                </WidgetOnly>
            }
        />
        <Route
            path="/dashboard/projects/:id/:view/:taskId"
            element={
                <WidgetOnly>
                    <ProjectDetail />
                </WidgetOnly>
            }
        />
    </>
)
